import { Task, TaskTimeline } from 'graphql-common';
import _find from 'lodash/find';

export default function mergeTasksWithTimeline(
  tasks: Task[],
  timelineData: TaskTimeline[],
): (Task & { timeline?: TaskTimeline })[] {
  return tasks.map((task) => {
    const timelineItem = _find(
      timelineData,
      (timeline: TaskTimeline) => timeline.id === task.id,
    );
    return {
      ...task,
      timeline: timelineItem,
    };
  });
}
